import { ArticleNonSubscriberAnnualModal } from '@public/components/Modals/Offers/Article/NonSubscriberAnnualModal';
import { type ComponentProps } from 'react';

export type OfferModalType = 'offers.article.non_subscriber_annual';

export interface OfferModalPropsMap {
  'offers.article.non_subscriber_annual': ComponentProps<
    typeof ArticleNonSubscriberAnnualModal
  >;
}

export const offerModals = {
  'offers.article.non_subscriber_annual': ArticleNonSubscriberAnnualModal,
};
